var map = {
	"./1.png": "775a",
	"./2.png": "8e30",
	"./3.png": "1f66",
	"./4.png": "5fa5",
	"./5.png": "c037a",
	"./6.png": "338d",
	"./code_img.png": "2c40",
	"./logo_img.png": "d662",
	"./qem-logo-white.png": "729e",
	"./txhl-logo-white.png": "5d71"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b967";